import styled from 'styled-components';

import { responsive } from '@/utils/scaleUi.ts';

import { radialPadColors } from './radialControlPad.constants.ts';

export const RadialPadRoot = styled.div<{ $size: number }>`
  position: relative;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  margin: 0 auto;
  user-select: none;
  border-radius: ${responsive.radius.rounded};
  background-color: ${radialPadColors.pad.background};
`;

export const RadialPadSvg = styled.svg`
  display: block;
  overflow: visible;
  background: transparent;
`;

/** HTML overlay for portaled sector tooltips (cannot render inside {@link RadialPadSvg}). */
export const RadialTooltipLayer = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
`;

export const RadialTooltipAnchor = styled.span<{ $left: number; $top: number }>`
  position: absolute;
  left: ${({ $left }) => $left}px;
  top: ${({ $top }) => $top}px;
  width: 1px;
  height: 1px;
  transform: translate(-50%, -50%);
  pointer-events: none;
`;
